<div style="background-color: #F5F7F8; height: 100vh; overflow-y: scroll; padding: 10px;">
    <img style="width: 22px; height: 22px; position: relative; top: 25px; left: 20px;" (click)="this.back()" src="/assets/images/shared/back.svg">
    <h3 style="text-align: center; font-weight: 600;">Ревюта</h3>
    <div style="width: 90%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
        <div class="row">
            <div class="col-4" style="text-align: center; padding-top: 20px;">
                <h3 style="text-align: center; font-weight: 600; font-size: 18px; margin-bottom: 10px;">{{ this.avrRatingAsString }}</h3>
                <ngb-rating [max]="5" [rate]="this.avrRating">
                    <ng-template let-fill="fill" let-index="index">
                        <i class="bi-star{{fill === 100 ? '-fill filled-rating' : ''}} rating " [class.filled]="fill === 100" [class.low]="index < 3"></i>
                    </ng-template>
                </ngb-rating>
                <p style="color: #ADAFBB; font-size: 14px;">{{ this.reviews.length + ((this.reviews.length == 1) ? ' ревю' : ' ревюта')}}</p>
            </div>
            <div class="col-8">
                <div class="row">
                    <div class="col-4">
                        <ngb-rating [max]="5" [rate]="5">
                            <ng-template let-fill="fill" let-index="index">
                                <i class="bi-star{{fill === 100 ? '-fill' : ''}} rating" [class.filled]="fill === 100" [class.low]="index < 3"></i>
                            </ng-template>
                        </ngb-rating>
                        <ngb-rating [max]="5" [rate]="4">
                            <ng-template let-fill="fill" let-index="index">
                                <i class="bi-star{{fill === 100 ? '-fill' : ''}} rating" [class.filled]="fill === 100" [class.low]="index < 3"></i>
                            </ng-template>
                        </ngb-rating>
                        <ngb-rating [max]="5" [rate]="3">
                            <ng-template let-fill="fill" let-index="index">
                                <i class="bi-star{{fill === 100 ? '-fill' : ''}} rating" [class.filled]="fill === 100" [class.low]="index < 3"></i>
                            </ng-template>
                        </ngb-rating>
                        <ngb-rating [max]="5" [rate]="2">
                            <ng-template let-fill="fill" let-index="index">
                                <i class="bi-star{{fill === 100 ? '-fill' : ''}} rating" [class.filled]="fill === 100" [class.low]="index < 3"></i>
                            </ng-template>
                        </ngb-rating>
                        <ngb-rating [max]="5" [rate]="1">
                            <ng-template let-fill="fill" let-index="index">
                                <i class="bi-star{{fill === 100 ? '-fill' : ''}} rating" [class.filled]="fill === 100" [class.low]="index < 3"></i>
                            </ng-template>
                        </ngb-rating>
                    </div>
                    <div class="col-8">
                        <p style="color: #ADAFBB; margin-bottom: 1px;"><ngb-progressbar  type="secondary" [value]="this.categorised[5].length"></ngb-progressbar> {{ this.categorised[5].length }}</p>
                        <p style="color: #ADAFBB; margin-bottom: 1px;"><ngb-progressbar  type="secondary" [value]="this.categorised[4].length"></ngb-progressbar> {{ this.categorised[4].length }}</p>
                        <p style="color: #ADAFBB; margin-bottom: 1px;"><ngb-progressbar  type="secondary" [value]="this.categorised[3].length"></ngb-progressbar> {{ this.categorised[3].length }}</p>
                        <p style="color: #ADAFBB; margin-bottom: 1px;"><ngb-progressbar  type="secondary" [value]="this.categorised[2].length"></ngb-progressbar> {{ this.categorised[2].length }}</p>
                        <p style="color: #ADAFBB; margin-bottom: 1px;"><ngb-progressbar  type="secondary" [value]="this.categorised[1].length"></ngb-progressbar> {{ this.categorised[1].length }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div style="width: 90%; margin: auto; margin-top: 10px; ">
        <div class="row justify-content-between" style="width: 100%; margin: auto;">

            <button  style="width: fit-content; height: 40px; border-radius: 7px; padding: 10px; border: none; background-color: white;" type="button" (click)="this.open(order)">
                {{ this.selectedOrder }} &nbsp;<i class="bi bi-caret-down-fill" style="position: relative; top: 2px;"></i>
            </button>
          <!-- <button class="col-4" style="width: fit-content; height: 40px; border-radius: 7px; padding: 10px; border: none; background-color: white;" type="button" (click)="this.open(interval)">
            {{ this.selectedInterval }}
          </button> -->
        </div>
    </div>
    <div style="width: 90%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;" *ngFor="let review of this.reviews">
        <div class="row">
            <div class="col-2">        
                <img class="rounded-circle" style="width: 40px; height: 40px; display: inline-block; margin-top: 10px;" [src]="review.user?.userImage || '/assets/images/shared/default-user-icon.png'"/>
            </div>
            <div class="col-6">
                <p style="margin-bottom: 0px; position: relative; top: 7px;"> {{this.userName(review)}}</p>
                <p style="margin-top: 5px; font-size: 10px; color: #ADAFBB;"> {{ this.date(review) }}</p>
            </div>
            <div class="col-4" style="position: relative; top: 7px;">
                <ngb-rating [max]="5" [rate]="review.rating">
                    <ng-template let-fill="fill" let-index="index">
                        <i class="bi-star{{fill === 100 ? '-fill filled-rating' : ''}} rating" [class.filled]="fill === 100" [class.low]="index < 3"></i>
                    </ng-template>
                </ngb-rating>
            </div>
        </div>
        <p style="margin-top: 7px; width: 90%; margin: auto;">
            {{ review.review }}
        </p>
    </div>
</div>


<ng-template #order let-modal>
    <div style="padding-top: 10px !important; padding-bottom: 10px !important;">
        <h3 class="offcanvas-title" id="staticBackdropLabel" style="text-align: center; font-weight: 700; width: 100%;">Подреди по:</h3>
        <!-- <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button> -->
        <div style="width: 100%;">
            <ul class="list-group list-group-flush" style="width: 80%; margin: auto; list-style-type: none;">
            <li style="position: relative; top: -5px;"  (click)="this.selectOrder('Най-нови', 'newest')" [id]="this.selectedOrder == 'Най-нови' ? 'active' : ''"> Най-нови</li>
            <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
            <li style="position: relative; top: -5px;" (click)="this.selectOrder('Най-стари', 'oldest')" [id]="this.selectedOrder == 'Най-стари' ? 'active' : ''">Най-стари</li>
            <!-- <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
            <li style="position: relative; top: -5px;" (click)="this.selectOrder('Най-скъпи', 'price')" [id]="this.selectedOrder == 'Най-скъпи' ? 'active' : ''">Най-скъпи</li>
            <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
            <li style="position: relative; top: -5px;" (click)="this.selectOrder('Най-евтини', '-price')" [id]="this.selectedOrder == 'Най-евтини' ? 'active' : ''">Най-евтини</li> -->
            </ul>
        </div>
    </div>
</ng-template>>


<ng-template #interval let-modal>
    <div style="padding-top: 10px !important; padding-bottom: 10px !important;">
        <h3 class="offcanvas-title" id="staticBackdropLabel" style="text-align: center; font-weight: 700; width: 100%;">Виж:</h3>
        <!-- <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button> -->
        <div style="width: 100%;">
            <ul class="list-group list-group-flush" style="width: 80%; margin: auto; list-style-type: none;">
            <li style="position: relative; top: -5px;" (click)="this.selectFilter('Всички', 0)" [id]="this.selectedInterval == 'Всички' ? 'active' : ''"> Всички</li>
            <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
            <li style="position: relative; top: -5px;" (click)="this.selectFilter('Последните 3 месеца', 3)" [id]="this.selectedInterval == 'Последните 3 месеца' ? 'active' : ''">Последните 3 месеца</li>
            <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
            <li style="position: relative; top: -5px;" (click)="this.selectFilter('Последните 6 месеца', 6)" [id]="this.selectedInterval == 'Последните 6 месеца' ? 'active' : ''">Последните 6 месеца</li>
            <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
            <li style="position: relative; top: -5px;" (click)="this.selectFilter('Последните 12 месеца', 12)" [id]="this.selectedInterval == 'Последните 12 месеца' ? 'active' : ''">Последните 12 месеца</li>
            </ul>
        </div>
    </div>
</ng-template>